var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("带货视频数 "),_c('span',{staticClass:"yx-color-text-primary font-bold"},[_vm._v(_vm._s(_vm.row.video_num))])]),_c('div',[_vm._v("带货商品数 "),_c('span',{staticClass:"yx-color-text-primary font-bold"},[_vm._v(_vm._s(_vm.row.product_num))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }